module.exports = __webpack_public_path__ + "static/media/sirenetta.56de54a5.png";